
import React, {FC, useState} from 'react';
import Button from 'components/Button';
import {Location} from 'components/TimePicker/types';
import {Routes} from 'constants/index';
import {Link} from 'gatsby';
import {LocationCard, Modal} from 'pages/booking/components/LocationCard';

import * as styles from './styles.module.scss';

type EventLocationProps = {
	location: Location
}

export const EventLocation: FC<EventLocationProps> = ({location}) => {
	const [mref, setModal] = useState<React.ReactNode>();
	const link = `${Routes.scanMe}/${location.details.slug}`;

	// If expand, create a modal wrapping the current
	// card and pass in the "modal" flag to customize content
	const onExpand = () => {
		const onHide = () => setModal(null);
		setModal(() => (
			<Modal onHide={onHide}>
				<LocationCard
					location={location}
					modal={{onHide}}
				/>
			</Modal>
		));
	};

	return (
		<div className={styles.location}>
			<div className={styles.content}>
				<div className={styles.text}>
					<Link to={link}>
						{location.details.name}
					</Link>
					<div className={styles.address}>
						{location.details.isStore ? (
							<span>Store</span>
						) : (
							<span>Mobile</span>
						)}{' • '}
						{location.details.address.addr1}{', '}
						{location.details.address.addr2}
					</div>
				</div>
				<div className={styles.button}>
					<Button variant='ol-green' onClick={onExpand}>
						See times
					</Button>
				</div>
			</div>
			{mref}
		</div>
	);
};
